import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormField } from '@app/forms/models/detail/FormField';
import { FormFieldType } from '@app/forms/enums/FormFieldTypes';
import { CerrixTextAreaComponent } from '@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component';
import { CerrixTextfieldComponent } from '@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component';
import { InputTooltipDirective } from '@app/shared/directives/input-tooltip.directive';

@Component({
    selector: "form-entry-text",
    templateUrl: "./form-entry-text.component.html",
    styleUrls: ["../../form-entry-field.component.scss"],
    imports: [FormsModule, CerrixTextAreaComponent, CerrixTextfieldComponent, InputTooltipDirective]
})
export class FormEntryTextComponent implements OnInit {
    @Input() field: FormField;
    @Input() readonly: boolean;
    @Input() answer: string;
    @Output() answerChange: EventEmitter<string> = new EventEmitter<string>();
    isArea: boolean;

    constructor() {}
    ngOnInit() {
        this.isArea = this.field.FieldType === FormFieldType.TextArea;
    }

    fieldChange() {
        this.answerChange.emit(this.answer);
    }
}